import React, { Component } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import firebase from "./firebase";
class NavbarBrand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoUrl: "",
      logoName: "",
      facebookUrl: "",
      instagramUrl: "",
    };
    this.getLogo();
  }
  render() {
    return (
      <div style={{ paddingTop: "50px" }}>
        <Navbar
          collapseOnSelect
          expand="md"
          bg="dark"
          variant="dark"
          fixed="top"
        >
          <a className="navbar-brand lg ml-2 " href="#Navbar">
            <img
              src={this.state.logoUrl}
              width="60"
              height="60"
              className="d-inline-block align-center "
              alt="logo"
              style={{ marginRight: "10px" }}
            ></img>
            {this.state.logoName}
          </a>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto ">
              <Nav.Link href="#Portfolio">Portfolio</Nav.Link>
              <Nav.Link href="#About">About</Nav.Link>
              <Nav.Link href="#Contact">Contact</Nav.Link>
            </Nav>
            <Nav className="nav justify-content-center">
              <a href={this.state.instagramUrl} target="_blank">
                <img
                  src="\images\icon_instagram.png"
                  width="30"
                  height="30"
                  className="d-inline-block "
                  alt=""
                  style={{ margin: "5px" }}
                ></img>
              </a>

              <a href={this.state.facebookUrl} target="_blank">
                <img
                  src="\images\icon_facebook.png"
                  width="30px"
                  height="30px"
                  className="d-inline-block "
                  alt=""
                  style={{ margin: "5px" }}
                ></img>
              </a>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    );
  }

  getLogo = () => {
    var self = this;
    firebase
      .database()
      .ref("/Logo/")
      .on("value", function (snapshot) {
        // console.log(snapshot.val());
        self.setState({ logoUrl: snapshot.val().imgUrl });
        self.setState({ logoName: snapshot.val().logoName });
        self.setState({ facebookUrl: snapshot.val().facebookUrl });
        self.setState({ instagramUrl: snapshot.val().instagramUrl });
      });
  };
}

export default NavbarBrand;
